module.exports = __webpack_public_path__ + "img/qian.c8ae4e8e.png";